var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab"},[_c('main',{staticClass:"page_container"},[_c('TableLogs',{attrs:{"data":_vm.data,"loading":_vm.loading,"link-keys":_vm.linkKeys,"keys":_vm.keys},on:{"fetch":_vm.onFetchData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }